import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-number',
    templateUrl: './dynamic-number.component.html',
    styleUrls: ['./dynamic-number.component.scss'],
    standalone: false
})
export class DynamicNumberComponent extends AbstractDynamicInput {

  @Input() hideLabels = false;

  constructor(translate: TranslateService) { super(translate) }

}